import { ProjectStatusQuery } from "../models/ProjectStatusQuery";
import { ProjectStatus } from "../models/ProjectStatus";
import { BaseDataService } from '../../../services/base/BaseDataService';

export class ProjectStatusService extends BaseDataService<ProjectStatus, ProjectStatusQuery> {
	protected prefixUrl: string = `ProjectStatuses`;
	
}